import qs from 'query-string'
import { domains } from '~/constants/domains'

const ELECTRON_BUNDLE_PROTOCOL = 'mangofiles:'

type ShareableUrlQuery = Record<string, string | number | undefined>

const getShareableOrigin = () =>
  window.location.protocol === ELECTRON_BUNDLE_PROTOCOL
    ? domains.WEB_APP()
    : window.location.origin

/**
 * Builds a link that opens in a browser. Packaged Electron serves the app from
 * `mangofiles://bundle`, so links are rebased onto the web-app host for the
 * current API environment. Defaults to the current route.
 */
export const getShareableWebAppUrl = (
  path = `${window.location.pathname}${window.location.search}`,
  query?: ShareableUrlQuery,
): string => {
  const url = new URL(path, getShareableOrigin()).toString()
  return query ? qs.stringifyUrl({ url, query }) : url
}
